import { createEffect, createSignal, Show } from "solid-js";
import { Portal } from "solid-js/web";
import QRCode from "qrcode";

export default function QrInvite(props: { url: string; onClose?: () => void }) {
  const [dataUrl, setDataUrl] = createSignal<string>("");

  createEffect(async () => {
    // Larger quiet zone prevents visual clipping inside rounded containers
    setDataUrl(await QRCode.toDataURL(props.url, { margin: 4 }));
  });

  return (
    <Portal>
      <div class="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center p-4 sm:p-6">
        <div class="bg-white rounded-lg p-4 w-[320px] sm:w-[360px] max-w-[90vw] max-h-[90vh] overflow-auto shadow-2xl">
          <h3 class="text-lg font-semibold mb-2">Scan to join</h3>
          <Show when={dataUrl()} fallback={<div>Generating QR…</div>}>
            <img
              src={dataUrl()}
              alt="QR"
              class="w-full h-auto max-h-[65vh] object-contain border bg-white p-2"
            />
          </Show>
          <p class="text-xs mt-2 break-all">
            <a href={props.url} target="_blank" rel="noopener">
              {props.url}
            </a>
          </p>
          <div class="text-right mt-3">
            <button class="px-3 py-1 border rounded" onClick={props.onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
}
